module.exports = __webpack_public_path__ + "static/img/boy-head.5a9b2e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/module-test-page/assets/boy-head.jpg
// module id = pqBA
// module chunks = 1